import React, { FC } from 'react'
import ja from 'date-fns/locale/ja'
import styles from 'styles/components/card.module.scss'
import { endOfMonth, startOfMonth, format } from 'date-fns'
import { Card, CardInner } from 'components/Card'

type Props = {
  amount: number
  couponAmount: number
  datetime: Date
  feeAmount: number
  storeNames: string[]
  total: number
  taxBreakdown?: {
    reduced_rate: {
      amount: number
      tax_rate: 8
    }
    standard_rate: {
      amount: number
      tax_rate: 10
    }
  }
}

const MonthlyReportCard: FC<Props> = React.memo((props) => {
  const { amount, couponAmount, datetime, feeAmount, storeNames, taxBreakdown, total } = props
  const startDate = format(startOfMonth(datetime), 'M月d日（E）', { locale: ja })
  const endDate = format(endOfMonth(datetime), 'M月d日（E）', { locale: ja })
  return (
    <Card>
      <CardInner>
        <ul className={styles.monthlyReport__list}>
          <li className={styles.monthlyReport__list__item}>
            <span>対象期間</span>
            <span>
              {startDate}〜{endDate}
            </span>
          </li>
          <li className={styles.monthlyReport__list__item}>
            <span>対象店舗</span>
            <span>{storeNames.join(', ')}</span>
          </li>
          <li className={taxBreakdown ? styles.monthlyReport__list__item_no_border : styles.monthlyReport__list__item}>
            <span>貴店売上</span>
            <span>{amount.toLocaleString()}円</span>
          </li>
          {taxBreakdown && (
            <>
              <li className={styles.monthlyReport__list__item_breakdown}>
                <span>内訳</span>
              </li>
              <li className={styles.monthlyReport__list__item_breakdown}>
                <span>• 軽減税率対象商品（税込:8%）</span>
                <span>{taxBreakdown.reduced_rate.amount.toLocaleString()}円</span>
              </li>
              <li
                className={`${styles.monthlyReport__list__item_breakdown} ${styles.monthlyReport__list__item_breakdown_last}`}
              >
                <span>• 標準税率商品（税込:10%）</span>
                <span>{taxBreakdown.standard_rate.amount.toLocaleString()}円</span>
              </li>
            </>
          )}
          <li className={styles.monthlyReport__list__item}>
            <span>クーポン利用による補填金額</span>
            <span>{couponAmount.toLocaleString()}円</span>
          </li>
          <li className={styles.monthlyReport__list__item}>
            <span>
              sacri手数料及び
              <br />
              手数料に関わる消費税（10％）
            </span>
            <span>{feeAmount.toLocaleString()}円</span>
          </li>
          <li className={styles.monthlyReport__list__item}>
            <span>手数料控除後売上額（税込）</span>
            <span>{total.toLocaleString()}円</span>
          </li>
        </ul>
      </CardInner>
    </Card>
  )
})

export default MonthlyReportCard
